import { createSlice } from "@reduxjs/toolkit";

// Get initial theme from localStorage or default to light
const initialTheme = localStorage.getItem("theme") || "light";

const themeReducer = createSlice({
  name: "theme",
  initialState: { mode: initialTheme },
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === "dark" ? "light" : "dark";
      localStorage.setItem("theme", state.mode); // Save in localStorage
    },
  },
});

export const { toggleTheme } = themeReducer.actions;
export default themeReducer.reducer;
